import { JOB_DETAIL_TAB } from './jobDetailTabs'

// Historia 160 — las rutas del contrato congelado (03-dominio.md §8.1, contrato-sun.md §1), en UN
// solo sitio. Todas son GET y llevan siempre el PAR (OF, job): `jobReferenceId` solo no identifica
// la OF (D4). La base `/endpoints/` la pone `Api_Functions`.

export const jobDetailBase = (fabricationOrderId, jobReferenceId) =>
  'mos/fabricationOrder/' + fabricationOrderId + '/job/' + jobReferenceId + '/detail'

/** D1 — `deviceId` es obligatorio: sin él Sun responde 400 `InvalidJobDetailRequest` (RN20). */
export const jobDetailUrl = (fabricationOrderId, jobReferenceId, deviceId) =>
  jobDetailBase(fabricationOrderId, jobReferenceId) + '?deviceId=' + deviceId

const BLOCK_PATH = {
  [JOB_DETAIL_TAB.MATERIALS]: '/materials', // D2
  [JOB_DETAIL_TAB.INSPECTIONS]: '/inspections', // D3
  [JOB_DETAIL_TAB.INCIDENCES]: '/incidences', // D4
  [JOB_DETAIL_TAB.PARTS]: '/parts' // D5
}

/** D2-D5 según la pestaña. */
export const jobDetailBlockUrl = (tab, fabricationOrderId, jobReferenceId) =>
  jobDetailBase(fabricationOrderId, jobReferenceId) + BLOCK_PATH[tab]

/** D6 — pieza seleccionada y su huella. */
export const jobDetailPartUrl = (fabricationOrderId, jobReferenceId, partId) =>
  jobDetailBase(fabricationOrderId, jobReferenceId) + '/parts/' + partId

/** D6a/D6b (historia 169, C1) — detalle bajo demanda de una fila de la huella; `block` ∈ {materials, inspections}.
 * UX-10 (2026-09-26): D6c/D6d (attempts/context) ya no se piden nunca; siguen construidos en Sun sin consumidor. */
export const jobDetailPartBlockUrl = (fabricationOrderId, jobReferenceId, partId, block) =>
  jobDetailPartUrl(fabricationOrderId, jobReferenceId, partId) + '/' + block

/** Miniatura de la referencia (D26 + E-2: `MOS` y `MOS PRODUCTION`); `v` = uuid, cache-bust. */
export const referenceThumbnailUrl = (partReferenceId, mainImageUuid = '') =>
  'partReference/' + partReferenceId + '/mainImage/thumbnail' +
  (mainImageUuid ? '?v=' + encodeURIComponent(mainImageUuid) : '')
